import React, { useState, useEffect } from "react";
import Label from "components/general/Label";
import {
  RESULT_STATUS,
  getResultStatusAsInteger
} from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import Competitor from "components/presentation/Competitor";
import { Collapse } from "react-bootstrap"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from 'components/common/SportCode'

export const WpoScorers = ({ results }) => {

  const resultStatus = results?.status?.code;
  let showScoretag = true
  let showCurrent = false
  if (getResultStatusAsInteger(resultStatus) < RESULT_STATUS.LIVE) {
    showScoretag = false;
  }

  if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE) {
    showCurrent = true && results?.periods?.find(p => p.p_code === 'PSO');
  }

  const scorers = getScorersData(results)
  let playerForTeam = ''
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const [isNavCollapsed2, setIsNavCollapsed2] = useState(false);
  const handleNavCollapse2 = () => setIsNavCollapsed2(!isNavCollapsed2);
  let scorersArray_H = scorers && scorers.filter(s => s.side === 'H')?.sort((a, b) => b.order - a.order)
  let scorersArray_A = scorers && scorers.filter(s => s.side === 'A')?.sort((a, b) => b.order - a.order)
  if (scorers) {
    playerForTeam = (
      <>
        <div className="flex-row w-100">
          <div className="text-center score-horizontal-extra-information-box-pso">
            <PsoScore results={results} />
          </div>
          <div className="text-center score-horizontal-extra-information-box">{showScoretag && <Label data='LabelScorers' />}</div>
          <div className="flex-column d-flex w-100" >
            <div className="d-flex justify-content-center">

              <div key='ScoreHome' className='d-flex  justify-content-end navbar-light  score-horizontal-extra-information-box-normal text-end w-40'>
                <div className="me-1">
                  <div>
                    {scorersArray_H?.map((item, index) => {
                      if (index === 0) {
                        return (
                          <span key={'OlympicRoundHome-' + item?.order} className="d-flex justify-content-end">
                            <Competitor hidePicture={true} hideNoc={true} {...item?.ath} /> <span className="ps-1">{item?.text}</span>
                          </span>
                        )
                      }
                    }
                    )}
                  </div>
                  <Collapse in={isNavCollapsed2}>
                    <div id="navbarsHome">
                      {scorersArray_H?.map((item, index) => {
                        if (index > 0) {
                          return (
                            <span key={'OlympicRoundHome-' + item?.order} className="d-flex justify-content-end">
                              <Competitor hidePicture={true} hideNoc={true} {...item?.ath} /> <span className="ps-1">{item?.text}</span>
                            </span>
                          )
                        }
                      }
                      )}
                    </div>
                  </Collapse>
                </div>
                <div  >
                  {scorersArray_H.length > 1 &&
                    <button
                      className="custom-toggler"
                      type="button"
                      style={{ border: "unset", backgroundColor: "transparent" }}
                      aria-controls="navbarsHome" aria-expanded={isNavCollapsed2}
                      onClick={handleNavCollapse2}>
                      <FontAwesomeIcon className=" font-icon fa-xs" icon={isNavCollapsed2 ? faCaretUp : faCaretDown} />
                    </button>
                  }
                </div>
              </div>

              <div key='ScoreCenter' className='score-horizontal-extra-information-box w-20 text-center'></div>

              <div key='ScoreAway' className='d-flex  justify-content-start navbar-light  score-horizontal-extra-information-box-normal text-start w-40'>
                <div  >
                  {scorersArray_A.length > 1 &&
                    <button
                      className="custom-toggler  "
                      type="button"
                      style={{ border: "unset", backgroundColor: "transparent" }}
                      aria-controls="navbarsAway" aria-expanded={isNavCollapsed}
                      onClick={handleNavCollapse}>
                      <FontAwesomeIcon className=" font-icon fa-xs" icon={isNavCollapsed ? faCaretUp : faCaretDown} />
                    </button>
                  }
                </div>
                <div className="ms-1">
                  <div>
                    {scorersArray_A?.map((item, index) => {
                      if (index === 0) {
                        return (
                          <span key={'OlympicRoundAway-' + item?.order} className="d-flex justify-content-start">
                            <Competitor hidePicture={true} hideNoc={true} {...item?.ath} /> <span className="ps-1">{item?.text}</span>
                          </span>
                        )
                      }
                    }
                    )}
                  </div>
                  <Collapse in={isNavCollapsed}>
                    <div id="navbarsAway">
                      {scorersArray_A?.map((item, index) => {
                        if (index > 0) {
                          return (
                            <span key={'OlympicRoundAway-' + item?.order} className="d-flex justify-content-start">
                              <Competitor hidePicture={true} hideNoc={true} {...item?.ath} /> <span className="ps-1">{item?.text}</span>
                            </span>
                          )
                        }
                      }
                      )}
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
  return playerForTeam;
}
const getScorersData = (results) => {
  let scorers = []
  results?.playByPlay?.forEach(p => {
    p?.actions?.sort((a, b) => a.pbpa_order -b.pbpa_order)?.forEach((a, index) => {
      if (a.pbpa_period !== 'PSO' && a.pbpa_Result === 'GOAL' && a.competitors && a.competitors[0].athletes && a.competitors[0]?.athletes[0]?.pbpat_code) {
        let when = a?.pbpa_When ? a?.pbpa_When : '';
        let period = p?.subcode ? p?.subcode : '';
        let scorer = {
          when: when,
          period: period,
          order: a?.pbpa_order,
          text : `${when} ${period} ${a?.pbpa_order}`
        }
        const athHome = results?.home?.teamAthletes?.find(item => item?.athlete?.code === a.competitors[0]?.athletes[0]?.pbpat_code);
        const athAway = results?.away?.teamAthletes?.find(item => item?.athlete?.code === a.competitors[0]?.athletes[0]?.pbpat_code);
        if (athHome) {
          scorer.ath = athHome?.athlete
          scorer.side = 'H'
        } else {
          scorer.ath = athAway?.athlete
          scorer.side = 'A'
        }
        scorers.push(scorer)
      }
    })
  })

  const scorersReduced = [];

  scorers?.forEach(s => {
    let multipleScorer = scorersReduced?.find(sr => sr?.ath === s?.ath);
    if (multipleScorer) {
        multipleScorer?.goals?.push({order:s?.order, period:s?.period, when:s?.when})
        multipleScorer.order = multipleScorer?.order > s?.order ?  multipleScorer?.order : s?.order;
    } else {
      s.goals = [{order:s?.order, period:s?.period, when:s?.when}];
      scorersReduced.push(s)
    }
  })

  scorersReduced.sort((a, b) => b?.order - a?.order);

  scorersReduced?.forEach(i => i?.goals?.sort((a,b) => 
    {if (a?.period === b?.period){
      return  b?.order - a?.order;
    } else {
      return a?.period < b?.period ? 1 : -1
    }}));
  
  scorersReduced.forEach(i => {
    i.text = '';
    i?.goals?.forEach(g => {
      i.text = i.text + (i.text ? ", " : "") + `${g?.when ? g?.when : ''} ${g?.period ? g?.period : ''}`
    })
  })

  return  scorersReduced

}

const PsoScore = ({ results }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const pso = results?.periods?.find(p => p.p_code === 'PSO')

  if (!pso) return (<></>);

  return (
    <>
      <div>
        <SportCode discipline={mirs_discipline} entity='@Period' code={'PSO'} />
      </div>
      <div>{pso?.home?.periodScore + ' - ' + pso?.away?.periodScore}</div>
    </>
  );

}